document.documentElement.classList.remove('no-js');

const money = cents => {
  try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: window.Shopify?.currency?.active || 'USD'}).format(cents/100); }
  catch(e){ return `$${(cents/100).toFixed(2)}`; }
};

customElements.define('ch-mobile-menu', class extends HTMLElement {
  connectedCallback(){
    const btn=this.querySelector('[data-menu-toggle]'); const panel=this.querySelector('[data-mobile-menu]');
    if(!btn||!panel)return;
    btn.addEventListener('click',()=>{const open=panel.hasAttribute('open'); open?panel.removeAttribute('open'):panel.setAttribute('open',''); btn.setAttribute('aria-expanded',String(!open)); btn.setAttribute('aria-label',open?'Open menu':'Close menu');});
  }
});

class PredictiveSearch extends HTMLElement {
  connectedCallback(){
    this.input=this.querySelector('[data-predictive-input]');
    this.results=this.querySelector('[data-predictive-results]');
    if(!this.input||!this.results)return;
    this.input.addEventListener('input', this.debounce(()=>this.search(),250));
  }
  async search(){
    const q=this.input.value.trim();
    if(q.length<2){this.results.innerHTML=''; return;}
    try{
      const url=`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search`;
      const r=await fetch(url); if(!r.ok) throw new Error('Search failed');
      const html=await r.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const section=doc.querySelector('#shopify-section-predictive-search');
      this.results.innerHTML=section ? section.innerHTML : '';
      this.input.setAttribute('aria-expanded', this.results.textContent.trim() ? 'true':'false');
    }catch(e){this.results.innerHTML='';}
  }
  debounce(fn,wait){let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn.apply(this,a),wait)}}
}
customElements.define('predictive-search', PredictiveSearch);

const searchOverlay=document.querySelector('[data-search-overlay]');
document.querySelectorAll('[data-search-open]').forEach(btn=>btn.addEventListener('click',()=>{
  if(!searchOverlay)return; searchOverlay.hidden=false; document.body.classList.add('overlay-open'); setTimeout(()=>searchOverlay.querySelector('input')?.focus(),20);
}));
document.querySelector('[data-search-close]')?.addEventListener('click',()=>{searchOverlay.hidden=true;document.body.classList.remove('overlay-open');document.querySelector('[data-search-open]')?.focus();});

const drawer=document.querySelector('[data-cart-drawer]');
const backdrop=document.querySelector('[data-cart-backdrop]');
const drawerBody=document.querySelector('[data-cart-drawer-body]');
const drawerFooter=document.querySelector('[data-cart-drawer-footer]');
const subtotal=document.querySelector('[data-cart-subtotal]');
function openCart(){ if(!drawer)return; drawer.setAttribute('open',''); drawer.setAttribute('aria-hidden','false'); backdrop.hidden=false; document.body.classList.add('overlay-open'); refreshCart(); }
function closeCart(){ if(!drawer)return; drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden','true'); backdrop.hidden=true; document.body.classList.remove('overlay-open'); }
document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',openCart));
document.querySelector('[data-cart-close]')?.addEventListener('click',closeCart);backdrop?.addEventListener('click',closeCart);

async function refreshCart(){
  if(!drawerBody)return;
  const r=await fetch(`${window.Shopify.routes.root}cart.js`); const cart=await r.json();
  document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
  drawerBody.innerHTML='';
  if(!cart.items.length){ drawerBody.innerHTML='<p class="muted">Your bag is empty.</p>'; drawerFooter.hidden=true; return; }
  cart.items.forEach(item=>{
    const row=document.createElement('div'); row.className='cart-drawer__item';
    if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.product_title;row.appendChild(img)}
    const meta=document.createElement('div');meta.className='cart-drawer__item-meta';
    const title=document.createElement('a');title.href=item.url;title.textContent=item.product_title;meta.appendChild(title);
    if(item.variant_title){const v=document.createElement('small');v.textContent=item.variant_title;meta.appendChild(v)}
    const qty=document.createElement('small');qty.textContent=`Qty ${item.quantity}`;meta.appendChild(qty);
    const price=document.createElement('strong');price.textContent=money(item.final_line_price);meta.appendChild(price);
    row.appendChild(meta); drawerBody.appendChild(row);
  });
  subtotal.textContent=money(cart.total_price); drawerFooter.hidden=false;
}

for(const form of document.querySelectorAll('[data-product-form]')){
  form.addEventListener('submit',async e=>{
    e.preventDefault(); const btn=form.querySelector('[data-add-to-cart]'); const status=form.querySelector('[data-product-status]');
    btn.disabled=true; const old=btn.textContent; btn.textContent='Adding…';
    try{const r=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});if(!r.ok)throw new Error((await r.json()).description||'Unable to add item');status.textContent='Added to bag.';await refreshCart();openCart();}
    catch(err){status.textContent=err.message;}
    finally{btn.disabled=false;btn.textContent=old;}
  });
}

for(const root of document.querySelectorAll('[data-product-root]')){
  const data=root.querySelector('[data-product-variants]'); if(!data)continue;
  const variants=JSON.parse(data.textContent); const hidden=root.querySelector('[data-variant-id]'); const price=root.querySelector('[data-product-price]'); const btn=root.querySelector('[data-add-to-cart]');
  root.querySelectorAll('.variant-radio').forEach(radio=>radio.addEventListener('change',()=>{
    const selected=[...root.querySelectorAll('.variant-option')].map(fs=>fs.querySelector('.variant-radio:checked')?.value);
    const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i])); if(!variant)return;
    hidden.value=variant.id; price.textContent=money(variant.price); btn.disabled=!variant.available; btn.textContent=variant.available?'Add to bag':'Sold out';
    const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState({},'',u);
  }));
}

const filterToggle=document.querySelector('[data-filter-toggle]'); const filterPanel=document.querySelector('[data-filter-panel]');
filterToggle?.addEventListener('click',()=>{const open=filterPanel?.hasAttribute('open');if(open)filterPanel.removeAttribute('open');else filterPanel?.setAttribute('open','');filterToggle.setAttribute('aria-expanded',String(!open));});
document.querySelector('[data-sort-select]')?.addEventListener('change',e=>e.target.form?.submit());

document.addEventListener('keydown',e=>{if(e.key==='Escape'){if(searchOverlay&&!searchOverlay.hidden){searchOverlay.hidden=true;document.querySelector('[data-search-open]')?.focus()} closeCart(); document.body.classList.remove('overlay-open')}});


/* Creative Heritage v1.5 — guaranteed one-image-at-a-time product gallery */
document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const viewport = gallery.querySelector('[data-gallery-viewport]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  const current = gallery.querySelector('[data-gallery-current]');
  const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];

  if (!slides.length) return;

  let activeIndex = 0;
  let touchStartX = null;
  let touchStartY = null;

  const show = index => {
    activeIndex = (index + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      const active = i === activeIndex;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    dots.forEach((dot, i) => {
      const active = i === activeIndex;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    if (current) current.textContent = String(activeIndex + 1);
    if (prev) prev.disabled = slides.length <= 1;
    if (next) next.disabled = slides.length <= 1;
  };

  prev?.addEventListener('click', () => show(activeIndex - 1));
  next?.addEventListener('click', () => show(activeIndex + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));

  viewport?.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      show(activeIndex - 1);
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      show(activeIndex + 1);
    }
  });

  viewport?.addEventListener('touchstart', e => {
    if (!e.touches.length) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  viewport?.addEventListener('touchend', e => {
    if (touchStartX === null || !e.changedTouches.length) return;

    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;

    touchStartX = null;
    touchStartY = null;

    // Horizontal swipe only; ignore vertical scrolling gestures.
    if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
    if (dx < 0) show(activeIndex + 1);
    else show(activeIndex - 1);
  }, { passive: true });

  show(0);
});
